import dayjs from 'dayjs';
import { getRiderLabel } from '../../../../../common/constants/rider';
import { BeneficiaryDetailsDto } from '../../../detailSlice';
import { LetterTypes } from './types';

export const dateFormat = 'MMM D, YYYY';

export const formatDate = (date: Date | string) => {
  return dayjs(date).format(dateFormat);
};

export const formatRidersText = (riders: string[] = []) => {
  const ridersNames = riders.map(rider => getRiderLabel(rider));
  if (ridersNames.length === 0) return '';

  if (ridersNames.length === 1) {
    const [riderName] = ridersNames;
    return `${riderName} rider`;
  }

  const allButLastName = ridersNames.slice(0, -1).join(', ');
  const lastName = ridersNames[ridersNames.length - 1];
  return `${allButLastName} and ${lastName} riders`;
};

export const getLetterTypeLabel = (letterType: LetterTypes) => {
  switch (letterType) {
    case LetterTypes.decline:
      return 'Decline';
    case LetterTypes.otaf:
      return 'OTAF';
    case LetterTypes.otafSamePrice:
      return 'OTAF';
    case LetterTypes.reinstatementApproval:
      return 'Reinstatement Approval';
    case LetterTypes.reinstatementDecline:
      return 'Reinstatement Decline';
    case LetterTypes.reinstatementWithdrawal:
      return 'Reinstatement Withdrawal';
    case LetterTypes.substandard:
      return 'Substandard';
    case LetterTypes.withdrawal:
      return 'Withdrawal';
    default:
      return 'Unknown';
  }
};

export const getLetterRecipientFullName = (
  isJuvenile: boolean,
  policyholderName: string | undefined | null,
  customerName: string | undefined | null,
): string => {
  if (isJuvenile && policyholderName) return policyholderName;
  return customerName ?? '';
};

export const getProposedInsuredName = (
  isJuvenile: boolean,
  beneficiaryDetails: BeneficiaryDetailsDto[] | undefined,
): string | undefined => {
  if (!isJuvenile) return undefined;
  const child = beneficiaryDetails?.find(b =>
    ['child', 'insured'].includes((b.relationships ?? '').toLowerCase()),
  );
  if (!child) return undefined;
  return (
    [child.firstName, child.middleName, child.lastName]
      .filter(Boolean)
      .join(' ') || child.name
  );
};

export const getLetterFileName = (letterType: LetterTypes) => {
  switch (letterType) {
    case LetterTypes.decline:
      return 'decline';
    case LetterTypes.otaf:
      return 'otaf';
    case LetterTypes.otafSamePrice:
      return 'otaf';
    case LetterTypes.reinstatementApproval:
      return 'reinstatement-approval';
    case LetterTypes.reinstatementDecline:
      return 'reinstatement-decline';
    case LetterTypes.reinstatementWithdrawal:
      return 'reinstatement-withdrawal';
    case LetterTypes.substandard:
      return 'substandard';
    case LetterTypes.withdrawal:
      return 'withdrawal';
    default:
      return 'unknown';
  }
};
